"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logout = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Logout = function Logout() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M45.69,35.63v13.73c0,1.87-1.73,3.38-3.86,3.38h-5.05"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M12.94,5.05h28.89c2.13,0,3.86,1.51,3.86,3.38v13.64"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
        points: "53.47,20.87 62.5,28.76 53.47,36.66 \t"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "62.1",
        y1: "28.76",
        x2: "37.79",
        y2: "28.76"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M26.85,59.89L5.22,54.5C3.64,54.22,2.5,53,2.5,51.59V12.46c0-1.88,1.98-3.29,4.09-2.91l21.64,5.39\r c1.58,0.28,2.72,1.5,2.72,2.91v39.13C30.94,58.86,28.96,60.27,26.85,59.89z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "20.99",
        y1: "37.38",
        x2: "20.99",
        y2: "37.38"
      })]
    })
  });
};
exports.Logout = Logout;